import { useIntl } from '@/intl'
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints'
import { getTransportSelector } from '@/scopes/prices/components/selectors'
import { BusSelectorDesktop } from '@/scopes/prices/components/TransportSelector/BusSelector/BusSelectorDesktop'
import { BusSelectorMobile } from '@/scopes/prices/components/TransportSelector/BusSelector/BusSelectorMobile'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { mqMin, space, tokPx } from '@sunwebgroup/ui-components'
import { Button, Dialog } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${space('primitives_space_8')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    gap: ${tokPx('primitives_space_24')};
    margin-bottom: 0;
  }
`
const ContentUnavailableWrapper = styled(Dialog)`
  margin: auto;
`

function BusSelector() {
  const intl = useIntl()
  const { isDesktopSm } = useBreakpoints()
  const { error } = usePricesSelector(getTransportSelector)

  if (error) {
    return (
      <ContentUnavailableWrapper
        text={intl.formatMessage({ id: 'prices_bus_selector_error_title' })}
        supportingText={intl.formatMessage({ id: 'prices_bus_selector_error_message' })}
        type="alert"
        actionsSlot={(
          <Button onClick={() => window.location.reload()}>
            {intl.formatMessage({ id: 'prices_error_reload_button' })}
          </Button>
        )}
      />
    )
  }

  return (
    <Wrapper>
      {isDesktopSm ? <BusSelectorDesktop /> : <BusSelectorMobile />}
    </Wrapper>
  )
}

export { BusSelector }
